import { createMaterialTopTabNavigator } from "@react-navigation/material-top-tabs";
import { FontAwesome } from "@expo/vector-icons";
import React, { useState, useEffect, useContext } from "react";
import { Pressable, TouchableOpacity } from "react-native";
import { View } from "../../../components/shared/Themed";
import Colors from "../../../utils/constants/colors";
import useColorScheme from "../../../hooks/useColorScheme";
import CompanyInfoScreen from "../../../screens/Settings/CompanySettingScreens/CompanySettingAccountScreen";

import CompanyLogo from "../../../components/core/CompanyLogo";
import TabBarIcon from "../../../components/core/TabBarIcon";
import TeamSettingScreen from "../../../screens/Settings/TeamMemberScreens/TeamSettingMemberScreen";
import CreateUserSettingsScreen from "../../../screens/Settings/CreateUserSettingScreens/CreateUserSettingsScreen";
import { RootTabParamList, RootTabScreenProps } from "../../../types";
import roleConfig from "../../../utils/constants/roles";
import oktaConfig from "../../../configs/okta";
import DeviceOrientationContext from "../../../components/context/DeviceOrientationContext";
import { useSelector } from "react-redux";

export default function OrgSettingsTabNavigator({ navigation }: any) {
  const colorScheme = useColorScheme();
  const { isSmallDevice } = useContext(DeviceOrientationContext);

  const { currentRole } = useSelector((state: any) => state.configurations);

  const Tab = createMaterialTopTabNavigator<RootTabParamList>();
  const ReturnHomeButton = (navigation: any) => {
    return (
      <Pressable
        onPress={() =>
          navigation.navigate("Root", {
            screen: "Home",
          })
        }
        style={({ pressed }) => ({
          opacity: pressed ? 0.5 : 1,
        })}
      >
        <FontAwesome
          name="home"
          size={25}
          color={Colors[colorScheme].text}
          style={{ marginRight: 15 }}
        />
      </Pressable>
    );
  };

  useEffect(() => {
    let isMounted = true;
    if (isMounted) {
      if (currentRole) {
        if (
          currentRole !== roleConfig.roles.admin &&
          currentRole != roleConfig.roles.owner
        ) {
          window.location.href = `${oktaConfig.api.redirectUri}`;
        }
      } else {
        window.location.href = `${oktaConfig.api.redirectUri}`;
      }
    }
    return () => {
      isMounted = false;
    };
  });

  return (
    <View
      style={{
        height: "100%",
        backgroundColor: colorScheme === "light" ? "#fafafa" : "#fafafa",
      }}
    >
      {!isSmallDevice && (
        <View style={{ flexDirection: "row", width: "100%", height: 60 }}>
          <View
            style={{
              justifyContent: "center",
              alignItems: "center",
              width: "40%",
              height: 60,
            }}
          >
            <CompanyLogo />
          </View>
          <View
            style={{
              justifyContent: "center",
              alignItems: "center",
              width: "60%",
              height: 60,
            }}
          >
            <TouchableOpacity
              onPress={() =>
                navigation.navigate("Root", {
                  screen: "Home",
                })
              }
            >
              <TabBarIcon name="home" color={"black"} />
            </TouchableOpacity>
          </View>
        </View>
      )}
      <Tab.Navigator
        initialRouteName="Company"
        title="Company"
        screenOptions={{
          tabBarActiveTintColor: Colors[colorScheme].tint,
          tabBarStyle: {
            display: isSmallDevice ? "none" : undefined,
            height: 50,
            width: "100%",
            alignSelf: "center",
            justifySelf: "center",
            borderTopWidth: 0,
            backgroundColor: colorScheme === "light" ? "#fafafa" : "#fafafa",
          },
          tabBarLabelStyle: {
            fontSize: 14,
            fontWeight: "bold",
            textTransform: "none",
          },
          tabBarItemStyle: {
            flex: 1,
          },
        }}
      >
        <Tab.Screen
          name="Company"
          component={CompanyInfoScreen}
          options={({ navigation }: RootTabScreenProps<"Company">) =>
            isSmallDevice
              ? {
                title: "",
                headerTitleAlign: "center",
                tabBarIcon: ({ color }) =>
                  isSmallDevice && (
                    <TabBarIcon name="briefcase" color={color} />
                  ),
                headerRight: () => ReturnHomeButton(navigation),
              }
              : {
                title: "Company",
              }
          }
        />

        {/* Teams tab hidden
        {currentRole !== roleConfig.roles.member && (
          <Tab.Screen
            name="Teams"
            component={TeamSettingScreen}
            options={({ navigation }: RootTabScreenProps<"Teams">) =>
              isSmallDevice
                ? {
                  title: "",
                  headerTitleAlign: "center",
                  tabBarIcon: ({ color }) =>
                    isSmallDevice && (
                      <TabBarIcon name="users" color={color} />
                    ),
                  headerRight: () => ReturnHomeButton(navigation),
                }
                : {
                  title: "Teams",
                }
            }
          />
        )}
        */}

        {currentRole !== roleConfig.roles.member && (
          <Tab.Screen
            name="Users"
            component={CreateUserSettingsScreen}
            options={({ navigation }: RootTabScreenProps<"Users">) =>
              isSmallDevice
                ? {
                  title: "",
                  headerTitleAlign: "center",
                  tabBarIcon: ({ color }) =>
                    isSmallDevice && (
                      <TabBarIcon name="users" color={color} />
                    ),
                  headerRight: () => ReturnHomeButton(navigation),
                }
                : {
                  title: "Users",
                }
            }
          />
        )}
      </Tab.Navigator>
    </View>
  );
}
